import {
  ApiCallState,
  callFailed,
  callInitiated,
  callSucceeded
} from '../../types'
import { Order } from '../order/types'
import { DepthOfMarketAction } from './actions'

export interface State {
  popoutSecurityIds: number[]
  domLimitExceeded: boolean
  maxDOMs: number
  depthBySecurity: Record<number, Order[]>
  apiCalls: Record<`${number}-${string}`, ApiCallState>
}

export const initialState: State = {
  popoutSecurityIds: [],
  domLimitExceeded: false,
  maxDOMs: 20,
  depthBySecurity: {},
  apiCalls: {}
}

export default (state = initialState, action: DepthOfMarketAction): State => {
  switch (action.type) {
    case 'depthofmarket.popout': {
      if (state.popoutSecurityIds.length >= state.maxDOMs) {
        return {
          ...state,
          domLimitExceeded: true
        }
      }
      return {
        ...state,
        popoutSecurityIds: [
          action.payload,
          ...state.popoutSecurityIds.filter(
            (securityId) => securityId !== action.payload
          )
        ]
      }
    }
    case 'depthofmarket.closePopout': {
      return {
        ...state,
        popoutSecurityIds: state.popoutSecurityIds.filter(
          (id) => id !== action.payload
        ),
        domLimitExceeded: false
      }
    }
    case 'depthofmarket.closeAllPopouts': {
      return {
        ...state,
        popoutSecurityIds: [],
        domLimitExceeded: false
      }
    }
    case 'depthofmarket.updatePopouts': {
      if (!state.popoutSecurityIds.includes(action.payload.previous)) {
        return state
      }

      const filteredIds = state.popoutSecurityIds.filter(
        (id) => id !== action.payload.current
      )

      return {
        ...state,
        popoutSecurityIds: filteredIds.map((id) =>
          id === action.payload.previous ? action.payload.current : id
        )
      }
    }
    case 'depthofmarket.setDomLimitExceeded': {
      return {
        ...state,
        domLimitExceeded: action.payload
      }
    }
    case 'depthofmarket.subscribeDepthForSecurity': {
      const key: `${number}-${string}` = `${action.payload.securityId}-${action.payload.callId}`
      return {
        ...state,
        apiCalls: { ...state.apiCalls, [key]: callInitiated }
      }
    }
    case 'depthofmarket.setDepthForSecurity': {
      const { securityId, orders, callId } = action.payload
      const key: `${number}-${string}` = `${securityId}-${callId}`
      if (!state.apiCalls[key]) return state
      return {
        ...state,
        depthBySecurity: {
          ...state.depthBySecurity,
          [securityId]: orders
        },
        apiCalls: { ...state.apiCalls, [key]: callSucceeded }
      }
    }
    case 'depthofmarket.setDepthForSecurityFailed': {
      const key: `${number}-${string}` = `${action.payload.securityId}-${action.payload.callId}`
      if (!state.apiCalls[key]) return state
      return {
        ...state,
        apiCalls: { ...state.apiCalls, [key]: callFailed }
      }
    }
    case 'depthofmarket.unsubscribeDepthForSecurity': {
      const key: `${number}-${string}` = `${action.payload.securityId}-${action.payload.callId}`
      const { [key]: _removed, ...remainingCalls } = state.apiCalls
      return {
        ...state,
        apiCalls: remainingCalls as State['apiCalls']
      }
    }
    default:
      return state
  }
}
